import React from 'react';

import { X_GAP } from '../../pages/mindmap/use-mindmap';

interface NodeDndPreviewProps {
  left: number;
  top: number;
}

export const NodeDndPreview = ({ left, top }: NodeDndPreviewProps) => {
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 999,
        top,
        left,
        height: 50,
        width: X_GAP * 2,
        backgroundColor: '#e5e5f7',
        borderRadius: 16,
        opacity: 0.95,
        boxShadow: 'rgba(0, 0, 100, 0.35) 0px 5px 15px',
      }}
    ></div>
  );
};
